export default __webpack_public_path__ + "static/media/N_Laminate.85c2cd8f.jpg";